import training from "../assets/images/training2.jpg";

export const TrainingData = [
  {
    categories: [
      {
        logo: training,
        id: 1,
        category: "Training",
        blog_heading: "Training Blogs",
        blogs: [
          {
            id: 101,
            title: "The Importance of Training",
            description:
              "Exploring why training is crucial for employee growth, productivity, and business success.",
          },
          {
            id: 102,
            title: "Video – The Benefits of Training Employees",
            description:
              "A video-based explanation of how employee training improves efficiency, engagement, and retention.",
          },
          {
            id: 103,
            title: "Categories of Training and Development for Employees",
            description:
              "An overview of different types of employee training, such as technical skills, leadership, and compliance training.",
          },
        ],
      },
      {
        id: 1,
        logo: training,
        category: "Training Partners",
        blog_heading: "Training Partners & Courses",
        blogs: [
          {
            id: 104,
            name: "SmartPal",
            website: "https://smartpal.ie/",
            description:
              "SmartPal offers high-quality training courses to enhance workplace safety and compliance.  At the end of the course learners will be able to:Identify the legal responsibilities of the employer and employee at workExplain the anatomy of the spinal columnRecognise how incorrect manual handling technique can lead to injuryOutline the benefits of fitness and flexibility in the workplaceDescribe the role of ergonomics and risk assessment in manual handlingState the 8 principles of safe manual handling ",
            courses: [
              {
                id: 201,
                title: "Manual Handling",
                description:
                  "Provides learners with the skills and knowledge for best manual handling techniques, workplace safety, and injury prevention.",
                course_link: "https://smartpal.ie/manual-handling/",
                modules: [
                  "Legal responsibilities of employer and employee",
                  "Anatomy of the spinal column",
                  "Incorrect manual handling techniques and injury prevention",
                  "Fitness and flexibility in the workplace",
                  "Ergonomics and risk assessment",
                  "8 principles of safe manual handling",
                  "Quiz and practical assessment",
                ],
              },
            ],
          },
          {
            id: 105,
            name: "Skills Direct",
            description:
              "Skills Direct provides a variety of safety and compliance courses for employees.",
            courses: [
              "Health & Safety Awareness",
              "Chemical Safety Awareness",
              "Fire Safety Awareness",
              "Food Safety Level 1",
              "Food Safety Level 2",
              "Infection, Prevention & Control",
              "Understanding GDPR",
              "Dignity at Work",
            ],
          },
          {
            id: 106,
            name: "Pro Shield Health & Safety",
            description:
              "Pro Shield offers safety and first aid training programs tailored to workplace needs.",
            courses: [
              "CFR – Cardiac First Responder",
              "FAR – First Aid Responder",
              "Fire Safety & Fire Warden",
              "Safety Consultancy",
              "Safety Representative",
            ],
          },
        ],
      },
      {
        id: 1,
        logo: training,
        category: "Training Academy",
        blog_heading: "Training Academy Programs",
        blogs: [
          {
            id: 107,
            title: "Hospitality Training",
            description:
              "Hospitality training programs designed to develop essential service industry skills.",
          },
          {
            id: 108,
            title: "Barista Training",
            description:
              "Comprehensive barista training covering coffee preparation techniques and customer service.",
          },
          {
            id: 109,
            title: "Bar Training",
            description:
              "A specialized course for bartenders covering mixology, customer service, and responsible alcohol service.",
          },
          {
            id: 110,
            title: "Forklift Training",
            description:
              "Certified forklift training for safe and efficient material handling in the workplace.",
          },
          {
            id: 111,
            title: "Construction Training",
            description:
              "Hands-on training for construction workers, including safety protocols and equipment handling.",
          },
          {
            id: 112,
            title: "Office Training",
            description:
              "Training programs designed to enhance office productivity and software skills.",
          },
        ],
      },
      {
        id: 1,
        logo: training,
        category: "Education",
        blog_heading: "Education & Career Development",
        blogs: [
          {
            id: 113,
            title: "Internships / Students / Graduates",
            description:
              "Providing opportunities for students and recent graduates to gain real-world experience.",
          },
          {
            id: 114,
            title: "College Placements",
            description:
              "Partnering with colleges to offer placement programs for students.",
          },
          {
            id: 115,
            title: "Graduate Programme",
            description:
              "A structured program to help graduates transition into professional roles.",
          },
          {
            id: 116,
            title: "Apprentice Programme",
            description:
              "Hands-on training programs for apprentices in various industries.",
          },
        ],
      },
    ],
  },
];
